<app-loading-overlay></app-loading-overlay>
<app-sidebar></app-sidebar>
<div class="main-content" [class.main-content-wide]="wideLayout">
  <app-topbar></app-topbar>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>
<div class="footer">
  <p *ngIf="!isUserSignedIn">Se hai bisogno di supporto chiama uno dei seguenti numeri: 349 3418784 - 391 1145413</p>
  <hr *ngIf="!isUserSignedIn">
  <p>TEVANPAL CONSULT SRL UNIPERSONALE</p>
  <p>P.I. 17772961003 - C.F. 17772961003 - Sede legale: Via Nomentana 351/A, Fonte Nuova (RM) - Capitale Sociale:
    10.000,00 euro i.v.</p>
</div>
